import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import "./index.css";

import "@fontsource/poppins";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// ✅ Service Worker
// ✅ Service Worker (Disabled)
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Get the root DOM element
const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container not found");
}

// Create root
// Render app (Modified for react-snap pre-rendering)
const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  // If pre-rendered content exists, hydrate it
  const { hydrateRoot } = require("react-dom/client");
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  // Regular render
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  );
}


// ✅ Manually Unregister Service Worker to fix 500 Error
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  }).catch((error) => {
    console.error(error.message);
  });
}
